import { getAuthHeaders, tempMeeApi } from '~/services/api';
import { ICreateShortlistCandidatePayload } from '../types';

export const createShortlistCandidate = async (
  payload: ICreateShortlistCandidatePayload,
): Promise<void> => {
  const headers = await getAuthHeaders();

  await tempMeeApi.post<void>(
    `/recruitment-service/candidates/${payload.candidateId}/shortlist`,
    {},
    { headers },
  );
};
